import React, { FormEvent, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { StoreState } from '../../store'
import * as actions from '../../store/modules/cerc/actions'
import api from '../../services/axios'
import validator from 'validator'
import swal from 'sweetalert'
import { get } from 'lodash'
import { cnpjCpfMask, foneMask, parseDate } from '../../utils/masks'
import { getIcon } from '../../utils/arranjos'
import {
    Container,
    DataUR,
    ReceiverData,
    Form,
    UnidadesRecebiveis,
    Table,
    ConfirmModal,
    Notice,
} from './styles'
import Dialog from '../../components/Dialog'
import {
    Autocomplete,
    Button,
    Checkbox,
    FormControlLabel,
    MenuItem,
    Select,
    TextField,
    Tooltip,
} from '@mui/material'
import { RiErrorWarningLine } from 'react-icons/ri'
import { useForm, SubmitHandler, Controller } from 'react-hook-form'
import { calcDiffDays } from '../../utils/date'
import { MdHelpOutline } from 'react-icons/md'
import { validateCnpjCpf } from '../../utils/validate'
import { useBancos } from '../../hooks/bancos'
import { useContacts } from '../../hooks/contacts'
import { useCommision } from '../../hooks/commission'
import { Link, useNavigate } from 'react-router-dom'
import { useCredenciadoras } from '../../hooks/credenciadoras'

interface Inputs {
    agencia: string
    compe: string
    email: string
    ispb: string
    nomeTitular: string
    numeroConta: string
    numeroDocumentoTitular: string
    observacao: string
    telefone: string
    tipoConta: string
}

const initialContact = {
    agencia: '',
    compe: '',
    email: '',
    ispb: '',
    nomeTitular: '',
    numeroConta: '',
    numeroDocumentoTitular: '',
    telefone: '',
    tipoConta: 'null',
    observacao: '',
    id: undefined,
}

const Pagar: React.FC = () => {
    const { unidadesRecebiveisSelecionadas } = useSelector(
        (state: StoreState) => state.cerc
    )
    const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)
    const { todasCredenciadoras } = useCredenciadoras()

    const navigate = useNavigate()
    const { bancos, getIspb } = useBancos()
    const { getPaymentCommission } = useCommision()
    const { saveContact, contacts } = useContacts()
    const dispatch = useDispatch()
    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
        getValues,
        setValue,
        reset,
    } = useForm<Inputs>()
    const [numeroConta, setNumeroConta] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [confirmModal, setConfirmModal] = useState(false)
    const [selectedFav, setSelectedFav] = useState(initialContact)
    // const [contacts, setContacts] = useState([])
    const [saveContactAsFavs, setSaveContactAsFavs] = useState(true)
    const [valueBanco, setValueBanco] = useState(['', ''])

    // const getContatosAndTax = useCallback(async () => {
    //     operation.attempt(async (currentAttempt) => {
    //     try {
    //         const { data } = await api.get(`/contatos/${cnpj_cpf}`)
    //         setContacts(data)

    //         // const response = await api.get(`/comissao/taxa/${cnpj_cpf}`)
    //         // setCommissionValue(response.data.valoresVariaveis)
    //         // setTaxa(response.data)

    //     } catch (error) {
    //     }
    //      });
    // }, [cnpj_cpf])
    // useEffect(() => {
    //     getContatosAndTax()
    // }, [getContatosAndTax])

    useEffect(() => {
        if (selectedFav?.id === undefined) {
            reset(initialContact)
            setNumeroConta('')
            setValueBanco(['', ''])
            return
        }
        // deselecionar a opcao salvar
        reset(selectedFav)
        setNumeroConta(selectedFav?.numeroConta)
        const compe = getValues('compe')
        const banco = bancos[compe]
        setValueBanco([compe, banco])
    }, [selectedFav, setValue, getValues, reset, bancos])

    const subtotal = unidadesRecebiveisSelecionadas.reduce((total, atual) => {
        return total + Number(atual.valorLivreSelecionado)
    }, 0)

    let commissonValue = getPaymentCommission(subtotal)

    const total =
        unidadesRecebiveisSelecionadas.length > 0
            ? Number((subtotal + commissonValue).toFixed(2))
            : 0

    const totalDias = unidadesRecebiveisSelecionadas.reduce(
        (total, unidade) => {
            const diffDays = calcDiffDays(unidade.dataLiquidacao)
            return total + diffDays
        },
        0
    )

    const prazoMedio = totalDias / unidadesRecebiveisSelecionadas.length

    // const credenciadora = unidadesRecebiveisSelecionadas[0]?.instituicaoCredenciadora || ''
    // const crendeciadora: keyof typeof todasCredenciadoras =
    //     unidadesRecebiveisSelecionadas[0]
    //         ?.instituicaoCredenciadora as keyof typeof todasCredenciadoras
    const nomeCredeciadora =
        todasCredenciadoras[
            unidadesRecebiveisSelecionadas[0]?.instituicaoCredenciadora
        ]
    if (unidadesRecebiveisSelecionadas.length === 0) {
        return (
            <Notice>
                <div>
                    <h2>Ops!</h2>
                    <h1 className="text-xl">
                        Você ainda não selecionou nenhuma unidade recebível!{' '}
                        <Link to="/pagamento">Clique aqui</Link> para começar!
                    </h1>
                </div>
                {/* <p>Selecione unidades de recebíveis para começar um contrato</p> */}
            </Notice>
        )
    }

    const submit: SubmitHandler<Inputs> = (inputs) => {
        setConfirmModal(true)
    }
    function handleChange(
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) {
        if (e.target.name === 'numeroConta') {
            let value = e.target.value
            value = value.replace(/\D/g, '')
            const array = value.split('')
            const ultimoDigito = array.pop()
            const contaSemDigito = array.join('')
            let conta = ultimoDigito
            if (array.length >= 1) {
                conta = `${contaSemDigito}-${ultimoDigito}`
            }
            e.target.value = conta || ''
            setNumeroConta(e.target.value)
        }
    }

    async function handleSubmitContract(e: FormEvent) {
        e.preventDefault()
        setIsLoading(true)
        setConfirmModal(false)
        try {
            const values = getValues()
            const dadosRecebedor = {
                ...values,
                numeroConta: numeroConta,
                numeroDocumentoTitular: values.numeroDocumentoTitular.replace(
                    /\D/g,
                    ''
                ),
                telefone: values.telefone.replace(/\D/g, ''),
                ispb: getIspb(values.compe),
            }

            if (saveContactAsFavs) {
                await saveContact({
                    ...dadosRecebedor,
                    cnpj_cpf,
                    contactId: selectedFav?.id || undefined,
                })
                // await api.post('/contato', {
                //     ...contratoData,
                //     cnpj_cpf,
                //     contactId: selectedFav?.id || undefined
                // })
            }

            await api.post('/contrato', {
                dadosRecebedor,
                unidadesRecebiveisSelecionadas,
                cnpj_cpf,
            })
            setIsLoading(false)
            swal({
                title: 'Contrato enviado com sucesso!',
                text: `Parabéns, seu contrato de ${subtotal.toLocaleString(
                    'pt-br',
                    { style: 'currency', currency: 'BRL' }
                )} foi submetido. Em breve você receberá novas informações por email.`,
                icon: 'success',
            })

            dispatch(actions.cercDeleteAllURs())
            navigate('/pagamento')
        } catch (error) {
            setIsLoading(false)
            const messageError = get(error, 'response.data.error', '')
            swal({
                title: 'Erro ao submeter contrato!',
                text: `${messageError}`,
                icon: 'error',
            })
        }
    }

    function renderUnidadeRecebivel() {
        return unidadesRecebiveisSelecionadas.map((unidade) => {
            const produto = unidade.codigoArranjoPagamento
            // const prodCod = arranjosPrincipais[produto]
            const diffDays = calcDiffDays(unidade.dataLiquidacao)
            // const crendeciadora: keyof typeof todasCredenciadoras =
            //     unidade.instituicaoCredenciadora as keyof typeof todasCredenciadoras
            const nomeCredeciadora =
                todasCredenciadoras[unidade?.instituicaoCredenciadora]
            return (
                <tr key={unidade.id}>
                    <td>
                        {parseDate(unidade.dataLiquidacao, true)} ({diffDays}{' '}
                        dias)
                    </td>
                    <td>{nomeCredeciadora}</td>
                    <td>
                        <img
                            height={35}
                            width={70}
                            src={getIcon(produto)}
                            alt="Icon bandeira cartão"
                        />
                    </td>
                    <td>
                        {Number(unidade.valorLivreSelecionado).toLocaleString(
                            'pt-br',
                            { style: 'currency', currency: 'BRL' }
                        )}
                    </td>
                </tr>
            )
        })
    }
    return (
        <Container>
            <DataUR>
                <h1>Gerar contrato</h1>
                <p>
                    Subtotal:{' '}
                    {subtotal.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                    })}
                </p>
                <p>
                    Taxa:{' '}
                    {commissonValue.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                    })}
                </p>
                <p>
                    Total:{' '}
                    {total.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                    })}
                </p>
                <p>
                    <span>Prazo médio de liquidação: </span>
                    {Math.round(prazoMedio) || 0} dias
                </p>
                <p>Credenciadora: {nomeCredeciadora}</p>
            </DataUR>
            <ReceiverData>
                <Form onSubmit={handleSubmit(submit)}>
                    <legend>Dados do recebedor</legend>
                    <div className="check-box">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={saveContactAsFavs}
                                    onChange={(e, newValue) =>
                                        setSaveContactAsFavs(newValue)
                                    }
                                />
                            }
                            label={'Salvar este contato como favorito'}
                        />
                        <Tooltip
                            title="Marque esta opção caso queria salvar estes dados como favoritos (ao selecionar um contato favorito e deixar essa opcão habilitada seu contato será atualizado com os novos dados)."
                            placement="top"
                        >
                            <span>
                                <MdHelpOutline size={18} />
                            </span>
                        </Tooltip>
                    </div>
                    <div className="input-group">
                        <div className="input-wrapper">
                            <Controller
                                defaultValue=""
                                name="nomeTitular"
                                control={control}
                                rules={{
                                    required:
                                        'O campo nome do titular é obrigatório',
                                    minLength: 3,
                                    maxLength: 100,
                                }}
                                render={({ field }) => (
                                    <Autocomplete
                                        freeSolo
                                        onChange={(event, newValue) => {
                                            // const value: string = newValue ? newValue[0] : ''
                                            setSelectedFav(newValue)
                                            setSaveContactAsFavs(false)
                                        }}
                                        onInputChange={(event, value) => {
                                            // const { data } = await api.get(`/comissao/taxa/${cnpj_cpf}`)
                                            // const inputEqualSomeContato = contatos.find((contato: any) => contato.nomeTitular === value)
                                            // if(!inputEqualSomeContato) {
                                            //     return field.onChange(value)
                                            // }
                                            field.onChange(value)

                                            // setSelectedFav(inputEqualSomeContato)
                                        }}
                                        getOptionLabel={(option: any) => {
                                            return option.nomeTitular ?? option
                                        }}
                                        // isOptionEqualToValue={(option, value) => {
                                        //     return option === value
                                        // }}
                                        disablePortal
                                        id="nomeTitular"
                                        options={contacts}
                                        sx={{
                                            width: '100%',
                                            fontFamily: 'Roboto',
                                            fontSize: '18px',
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label=""
                                                placeholder="Nome do titular"
                                            />
                                        )}
                                    />
                                )}
                            />
                            {/* <Controller defaultValue='' name='nomeTitular' control={control} rules={{ required: 'O campo nome do titular é obrigatório', minLength: 3, maxLength: 100 }} render={({ field }) => <TextField {...field} className='input' id="nomeTitular" placeholder="Nome do titular" variant="outlined" />} /> */}
                            {errors.nomeTitular &&
                                errors.nomeTitular.type === 'required' && (
                                    <span className="hook-error">
                                        {errors.nomeTitular.message}
                                    </span>
                                )}
                            {errors.nomeTitular &&
                                errors.nomeTitular.type === 'minLength' && (
                                    <span className="hook-error">
                                        O campo nome do titular deve ter pelo
                                        menos 3 caracteres
                                    </span>
                                )}
                            {errors.nomeTitular &&
                                errors.nomeTitular.type === 'maxLength' && (
                                    <span className="hook-error">
                                        O campo nome do titular deve ter no
                                        máximo 100 caracteres
                                    </span>
                                )}
                        </div>
                    </div>

                    <div className="input-group">
                        <div className="input-wrapper">
                            <Controller
                                defaultValue=""
                                name="numeroDocumentoTitular"
                                control={control}
                                rules={{
                                    required:
                                        'O campo Cnpj ou Cpf é obrigatório',
                                    validate: (value: string) =>
                                        validateCnpjCpf(value),
                                }}
                                render={({ field: { value, ...field } }) => (
                                    <TextField
                                        {...field}
                                        value={cnpjCpfMask(value || '')}
                                        className="input"
                                        id="numeroDocumentoTitular"
                                        placeholder="CPF/CNPJ"
                                        variant="outlined"
                                    />
                                )}
                            />
                            {errors.numeroDocumentoTitular &&
                                errors.numeroDocumentoTitular.type ===
                                    'required' && (
                                    <span className="hook-error">
                                        {errors.numeroDocumentoTitular.message}
                                    </span>
                                )}
                            {errors.numeroDocumentoTitular &&
                                errors.numeroDocumentoTitular.type ===
                                    'validate' && (
                                    <span className="hook-error">
                                        CPF/CNPJ inválido
                                    </span>
                                )}
                            {/* {errors.numeroDocumentoTitular && errors.numeroDocumentoTitular.type === 'maxLength' && (<span className='hook-error'>O campo Cnpj ou Cpf deve ter no máximo 18 caracteres</span>)} */}
                        </div>
                        <div className="input-wrapper">
                            <Controller
                                defaultValue=""
                                name="compe"
                                control={control}
                                rules={{
                                    required: 'O campo banco é obrigatório',
                                }}
                                render={({ field }) => (
                                    <Autocomplete
                                        onChange={(event, newValue) => {
                                            const value: string = newValue
                                                ? newValue[0]
                                                : ''

                                            setValueBanco(newValue || ['', ''])

                                            field.onChange(value)
                                        }}
                                        onInputChange={(event, value) => {
                                            // const { data } = await api.get(`/comissao/taxa/${cnpj_cpf}`)
                                            // if(value === '') setSelectedFav({})
                                            const compe = value
                                                .split('-')[0]
                                                .trim()

                                            field.onChange(compe)
                                        }}
                                        getOptionLabel={(option) => {
                                            return option[1]
                                        }}
                                        isOptionEqualToValue={(
                                            option,
                                            value
                                        ) => {
                                            return option[0] === value[0]
                                        }}
                                        disablePortal
                                        value={valueBanco}
                                        id="compe"
                                        options={Object.entries(bancos)}
                                        sx={{
                                            width: '100%',
                                            fontFamily: 'Roboto',
                                            fontSize: '18px',
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label=""
                                                placeholder="Banco"
                                            />
                                        )}
                                    />
                                )}
                            />
                            {errors.compe &&
                                errors.compe.type === 'required' && (
                                    <span className="hook-error">
                                        {errors.compe.message}
                                    </span>
                                )}
                        </div>
                    </div>

                    <div className="input-group tripple">
                        <div className="input-wrapper">
                            <Controller
                                defaultValue=""
                                name="agencia"
                                control={control}
                                rules={{
                                    required: 'O campo agencia é obrigatório',
                                    minLength: 2,
                                    maxLength: 10,
                                }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        className="input"
                                        id="agencia"
                                        placeholder="Agência"
                                        variant="outlined"
                                    />
                                )}
                            />
                            {errors.agencia &&
                                errors.agencia.type === 'required' && (
                                    <span className="hook-error">
                                        {errors.agencia.message}
                                    </span>
                                )}
                            {errors.agencia &&
                                errors.agencia.type === 'minLength' && (
                                    <span className="hook-error">
                                        O campo agência deve ter pelo menos 2
                                        caracteres
                                    </span>
                                )}
                            {errors.agencia &&
                                errors.agencia.type === 'maxLength' && (
                                    <span className="hook-error">
                                        O campo agência deve ter no máximo 10
                                        caracteres
                                    </span>
                                )}
                        </div>
                        <div className="input-wrapper">
                            <Controller
                                defaultValue=""
                                name="numeroConta"
                                control={control}
                                rules={{
                                    required:
                                        'O campo número da conta é obrigatório',
                                    onChange: (e) => handleChange(e),
                                }}
                                render={({ field: { value, ...field } }) => (
                                    <TextField
                                        {...field}
                                        value={numeroConta}
                                        onChange={(e) => field.onChange(e)}
                                        className="input"
                                        id="numeroConta"
                                        placeholder="Número da conta"
                                        variant="outlined"
                                    />
                                )}
                            />
                            {errors.numeroConta &&
                                errors.numeroConta.type === 'required' && (
                                    <span className="hook-error">
                                        {errors.numeroConta.message}
                                    </span>
                                )}
                        </div>
                        <div className="input-wrapper">
                            <Controller
                                defaultValue="null"
                                name="tipoConta"
                                control={control}
                                rules={{
                                    required: 'Selecione o tipo da conta',
                                    validate: (tipo: string) =>
                                        !(tipo === 'null'),
                                }}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        sx={{ width: '100%' }}
                                        labelId="tipoConta-label"
                                        id="tipoConta-select"
                                        placeholder="Tipo de conta"
                                    >
                                        <MenuItem disabled value="null">
                                            Selecionar tipo de conta
                                        </MenuItem>
                                        <MenuItem value="CC">
                                            CC - Conta Corrente
                                        </MenuItem>
                                        {/* <MenuItem value='CD'>CD - Conta de Depósito</MenuItem> */}
                                        {/* <MenuItem value='CG'>CG - Conta Garantia</MenuItem> */}
                                        {/* <MenuItem value='CI'>CI - Conta Investimento</MenuItem> */}
                                        {/* <MenuItem value='CP'>CP - Conta de Pagamento</MenuItem> */}
                                        <MenuItem value="PP">
                                            PP - Conta Poupança
                                        </MenuItem>
                                    </Select>
                                )}
                            />
                            {errors.tipoConta &&
                                errors.tipoConta.type === 'validate' && (
                                    <span className="hook-error">
                                        Selecione o tipo da conta
                                    </span>
                                )}
                        </div>
                    </div>
                    <div className="input-group">
                        <div className="input-wrapper">
                            <Controller
                                defaultValue=""
                                name="email"
                                control={control}
                                rules={{
                                    required: 'O campo email é obrigatório',
                                    validate: (email: string) =>
                                        validator.isEmail(email),
                                }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        className="input"
                                        id="email"
                                        placeholder="Email"
                                        variant="outlined"
                                    />
                                )}
                            />
                            {errors.email &&
                                errors.email.type === 'required' && (
                                    <span className="hook-error">
                                        {errors.email.message}
                                    </span>
                                )}
                            {errors.email &&
                                errors.email.type === 'validate' && (
                                    <span className="hook-error">
                                        Digite um email válido
                                    </span>
                                )}
                        </div>
                        <div className="input-wrapper">
                            <Controller
                                defaultValue=""
                                name="telefone"
                                control={control}
                                render={({ field: { value, ...field } }) => (
                                    <TextField
                                        {...field}
                                        value={foneMask(value || '')}
                                        className="input"
                                        id="telefone"
                                        placeholder="Telefone"
                                        variant="outlined"
                                    />
                                )}
                            />
                        </div>
                    </div>

                    <div className="input-group">
                        <div className="input-wrapper text-area">
                            <textarea
                                defaultValue=""
                                {...register('observacao')}
                                className="text-area"
                                name="observacao"
                                id=""
                                placeholder="Digite uma observação ou descrição sobre o contrato"
                            ></textarea>
                        </div>
                    </div>

                    <div className="actions">
                        <Button
                            disabled={isLoading}
                            type="submit"
                            variant="contained"
                        >
                            Enviar contrato
                        </Button>
                    </div>
                </Form>
            </ReceiverData>

            <UnidadesRecebiveis>
                <h2>Unidades Recebíveis Selecionadas</h2>
                <Table>
                    <thead>
                        <tr>
                            <th>Data de vencimento</th>
                            <th>Credenciadora</th>
                            <th>Bandeira</th>
                            <th>Valor selecionado (UR)</th>
                        </tr>
                    </thead>

                    <tbody>{renderUnidadeRecebivel()}</tbody>
                </Table>
            </UnidadesRecebiveis>
            <Dialog
                setIsTermsOpen={setConfirmModal}
                width="sm"
                isTermsOpen={confirmModal}
                title="Dados do recebedor"
            >
                <ConfirmModal
                    onSubmit={handleSubmitContract}
                    id="confirme-modal"
                >
                    <div className="title">
                        <h3>Por favor, confirme se os dados estão corretos</h3>
                        <RiErrorWarningLine color="ff6600" size={22} />
                    </div>
                    <div className="content">
                        <p>
                            <span>Valor do contrato:</span>{' '}
                            {subtotal.toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                            })}
                        </p>
                        <p>
                            <span>Nome do recebedor:</span>{' '}
                            {getValues('nomeTitular')}
                        </p>
                        <p>
                            <span>CPF/CNPJ do recebedor:</span>{' '}
                            {cnpjCpfMask(
                                getValues('numeroDocumentoTitular') || ''
                            )}
                        </p>
                        <p>
                            <span>Banco:</span> {bancos[getValues('compe')]}
                        </p>
                        <p>
                            <span>Compe:</span> {getValues('compe')}
                        </p>
                        <p>
                            <span>Ispb: </span> {getIspb(getValues('compe'))}
                        </p>
                        <p>
                            <span>Agência:</span> {getValues('agencia')}
                        </p>
                        <p>
                            <span>Número da conta:</span> {numeroConta}
                        </p>
                        <p>
                            <span>Tipo da conta:</span> {getValues('tipoConta')}
                        </p>
                        <p>
                            <span>Email:</span> {getValues('email')}
                        </p>
                        <p>
                            <span>Telefone:</span>{' '}
                            {foneMask(getValues('telefone') || '')}
                        </p>
                    </div>
                    <div className="actions">
                        <Button
                            variant="contained"
                            type="submit"
                            form="confirme-modal"
                            disabled={isLoading}
                        >
                            Confirmar dados
                        </Button>
                    </div>
                </ConfirmModal>
            </Dialog>
        </Container>
    )
}

export default Pagar
